"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var satcheljs_1 = require("satcheljs");
exports.default = satcheljs_1.createStore('calendarConfiguration', {
    calendarConfiguration: null,
})();
//# sourceMappingURL=store.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/options/config/owa-calendar-configuration/lib/store/store.js
// module id = 3413
// module chunks = 2